export default "/dist/files/xls.1127e9dfd150c81a304bfb0be9e2f139.svg";